import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { TDSComponent } from './tds.component';
import { FormsModule } from '@angular/forms';
import { AngularMaterialModule } from 'src/app/material.module';
export const baseRoutes: Routes = [
  {
    path: '',
    component: TDSComponent,
    data: {
      title: 'TDS'
    }
  }
];

@NgModule({
  imports: [
    CommonModule, FormsModule, AngularMaterialModule,
    RouterModule.forChild(baseRoutes),
  ],
  declarations: [TDSComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class TDSModule { }